/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useCallback } from 'react';
import { useLogger } from '@airasia-rn/core-logger';
import { ERROR_EVENT } from '../config/analytics';
import { buildSsoErrorEventParams } from '../utils/ssoErrors';

/** Logs a failed Login / Sign Up request as the SSO `errors` event. */
export function useSsoErrorReporter(screenName: string) {
  const { logEvent } = useLogger();

  return useCallback(
    (error: unknown, message: string) => {
      logEvent(
        ERROR_EVENT,
        buildSsoErrorEventParams(error, message, screenName),
      );
    },
    [logEvent, screenName],
  );
}
